<div class="autocont f-black roboto-l f-bmed pull-left vcenter">
    <div class="f-big padding-top1">
        Plan Actual
    </div>
</div>
<div class="basicrow m-top-ii">
    <div class="logline full"></div>
</div>
<div id="viewPlanBase" class="basicrow m-top-i">
    <app-currentplan-changeplan-box [currentPlan]="this.currentPlan" [plazo_equipo]="plac_eq" [serv_ad]="add_serv" [actualPrice]="actualPrice" [descr_plan]="plan_desc" [type_plan]="plan_type" [ins_eq]="equ_instal">
    </app-currentplan-changeplan-box>
</div>